import { render, staticRenderFns } from "./DDragAndDropBase.vue?vue&type=template&id=7780cc65&scoped=true&lang=pug"
import script from "./DDragAndDropBase.vue?vue&type=script&lang=js"
export * from "./DDragAndDropBase.vue?vue&type=script&lang=js"
import style0 from "./DDragAndDropBase.vue?vue&type=style&index=0&id=7780cc65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7780cc65",
  null
  
)

export default component.exports